// internal dependencies
import { getTransactions } from "../../../routes/get-transactions";
import { getTransactionsV1 } from "../../../routes/get-transactions-v1";
import { IndividualTransaction, ITransactionResponse } from "../../../models/transactions.interface";
import { formatDateToLocalString } from "../common/format-date-localstring";

interface ModelData {
  startDate: string;
  endDate: string;
  showErrors: number;
}

/**
 * Prepares the model data for the transaction api.
 * 
 * @param startDate 
 * @param endDate 
 * @returns 
 */
const getModelData = (startDate: Date, endDate: Date): ModelData => {
  return {
    startDate: formatDateToLocalString(startDate),
    endDate: formatDateToLocalString(endDate),
    showErrors: 0
  };
};

/**
 * Fetches the initial transaction data for the dashboard transactions table.
 * 
 * @param startDate the start date
 * @param endDate the end date
 * @returns IndividualTransaction list or empty list if error occurs
 */
export const getInitalTransactionData = async (startDate: Date, endDate: Date): Promise<IndividualTransaction[] | []> => {
  try {
    const datav1 = await getTransactionsV1(getModelData(startDate, endDate));

    return datav1.body;
  } catch (error) {
    console.error("Error fetching initial transaction data:", error);
    return [];
  }
};